import m from "dayjs";
function x(u, h) {
  for (var a = 0; a < h.length; a++) {
    const e = h[a];
    if (typeof e != "string" && !Array.isArray(e)) {
      for (const r in e)
        if (r !== "default" && !(r in u)) {
          const d = Object.getOwnPropertyDescriptor(e, r);
          d && Object.defineProperty(u, r, d.get ? d : {
            enumerable: !0,
            get: () => e[r]
          });
        }
    }
  }
  return Object.freeze(Object.defineProperty(u, Symbol.toStringTag, { value: "Module" }));
}
var y = typeof globalThis < "u" ? globalThis : typeof window < "u" ? window : typeof global < "u" ? global : typeof self < "u" ? self : {};
function M(u) {
  return u && u.__esModule && Object.prototype.hasOwnProperty.call(u, "default") ? u.default : u;
}
var D = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    var a = "day";
    return function(e, r, d) {
      var o = function(s) {
        return s.add(4 - s.isoWeekday(), a);
      }, i = r.prototype;
      i.isoWeekYear = function() {
        return o(this).year();
      }, i.isoWeek = function(s) {
        if (!this.$utils().u(s)) return this.add(7 * (s - this.isoWeek()), a);
        var c, t, n, l, v = o(this), p = (c = this.isoWeekYear(), t = this.$u, n = (t ? d.utc : d)().year(c).startOf("year"), l = 4 - n.isoWeekday(), n.isoWeekday() > 4 && (l += 7), n.add(l, a));
        return v.diff(p, "week") + 1;
      }, i.isoWeekday = function(s) {
        return this.$utils().u(s) ? this.day() || 7 : this.day(this.day() % 7 ? s : s - 7);
      };
      var f = i.startOf;
      i.startOf = function(s, c) {
        var t = this.$utils(), n = !!t.u(c) || c;
        return t.p(s) === "isoweek" ? n ? this.date(this.date() - (this.isoWeekday() - 1)).startOf("day") : this.date(this.date() - 1 - (this.isoWeekday() - 1) + 7).endOf("day") : f.bind(this)(s, c);
      };
    };
  });
})(D);
var q = D.exports;
const F = /* @__PURE__ */ M(q);
var S = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    var a = "month", e = "quarter";
    return function(r, d) {
      var o = d.prototype;
      o.quarter = function(s) {
        return this.$utils().u(s) ? Math.ceil((this.month() + 1) / 3) : this.month(this.month() % 3 + 3 * (s - 1));
      };
      var i = o.add;
      o.add = function(s, c) {
        return s = Number(s), this.$utils().p(c) === e ? this.add(3 * s, a) : i.bind(this)(s, c);
      };
      var f = o.startOf;
      o.startOf = function(s, c) {
        var t = this.$utils(), n = !!t.u(c) || c;
        if (t.p(s) === e) {
          var l = this.quarter() - 1;
          return n ? this.month(3 * l).startOf(a).startOf("day") : this.month(3 * l + 2).endOf(a).endOf("day");
        }
        return f.bind(this)(s, c);
      };
    };
  });
})(S);
var z = S.exports;
const P = /* @__PURE__ */ M(z);
var b = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    var a = { LTS: "h:mm:ss A", LT: "h:mm A", L: "MM/DD/YYYY", LL: "MMMM D, YYYY", LLL: "MMMM D, YYYY h:mm A", LLLL: "dddd, MMMM D, YYYY h:mm A" };
    return function(e, r, d) {
      var o = r.prototype, i = o.format;
      d.en.formats = a, o.format = function(f) {
        f === void 0 && (f = "YYYY-MM-DDTHH:mm:ssZ");
        var s = this.$locale().formats, c = function(t, n) {
          return t.replace(/(\[[^\]]+])|(LTS?|l{1,4}|L{1,4})/g, function(l, v, p) {
            var _ = p && p.toUpperCase();
            return v || n[p] || a[p] || n[_].replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(L, k, Y) {
              return k || Y.slice(1);
            });
          });
        }(f, s === void 0 ? {} : s);
        return i.call(this, c);
      };
    };
  });
})(b);
var C = b.exports;
const J = /* @__PURE__ */ M(C);
var O = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    return function(a, e) {
      e.prototype.weekday = function(r) {
        var d = this.$locale().weekStart || 0, o = this.$W, i = (o < d ? o + 7 : o) - d;
        return this.$utils().u(r) ? i : this.subtract(i, "day").add(r, "day");
      };
    };
  });
})(O);
var N = O.exports;
const U = /* @__PURE__ */ M(N);
var $ = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    return function(a, e, r) {
      var d = e.prototype, o = function(t) {
        return t && (t.indexOf ? t : t.s);
      }, i = function(t, n, l, v, p) {
        var _ = t.name ? t : t.$locale(), L = o(_[n]), k = o(_[l]), Y = L || k.map(function(w) {
          return w.slice(0, v);
        });
        if (!p) return Y;
        var E = _.weekStart;
        return Y.map(function(w, H) {
          return Y[(H + (E || 0)) % 7];
        });
      }, f = function() {
        return r.Ls[r.locale()];
      }, s = function(t, n) {
        return t.formats[n] || function(l) {
          return l.replace(/(\[[^\]]+])|(MMMM|MM|DD|dddd)/g, function(v, p, _) {
            return p || _.slice(1);
          });
        }(t.formats[n.toUpperCase()]);
      }, c = function() {
        var t = this;
        return { months: function(n) {
          return n ? n.format("MMMM") : i(t, "months");
        }, monthsShort: function(n) {
          return n ? n.format("MMM") : i(t, "monthsShort", "months", 3);
        }, firstDayOfWeek: function() {
          return t.$locale().weekStart || 0;
        }, weekdays: function(n) {
          return n ? n.format("dddd") : i(t, "weekdays");
        }, weekdaysMin: function(n) {
          return n ? n.format("dd") : i(t, "weekdaysMin", "weekdays", 2);
        }, weekdaysShort: function(n) {
          return n ? n.format("ddd") : i(t, "weekdaysShort", "weekdays", 3);
        }, longDateFormat: function(n) {
          return s(t.$locale(), n);
        }, meridiem: this.$locale().meridiem, ordinal: this.$locale().ordinal };
      };
      d.localeData = function() {
        return c.bind(this)();
      }, r.localeData = function() {
        var t = f();
        return { firstDayOfWeek: function() {
          return t.weekStart || 0;
        }, weekdays: function() {
          return r.weekdays();
        }, weekdaysShort: function() {
          return r.weekdaysShort();
        }, weekdaysMin: function() {
          return r.weekdaysMin();
        }, months: function() {
          return r.months();
        }, monthsShort: function() {
          return r.monthsShort();
        }, longDateFormat: function(n) {
          return s(t, n);
        }, meridiem: t.meridiem, ordinal: t.ordinal };
      }, r.months = function() {
        return i(f(), "months");
      }, r.monthsShort = function() {
        return i(f(), "monthsShort", "months", 3);
      }, r.weekdays = function(t) {
        return i(f(), "weekdays", null, null, t);
      }, r.weekdaysShort = function(t) {
        return i(f(), "weekdaysShort", "weekdays", 3, t);
      }, r.weekdaysMin = function(t) {
        return i(f(), "weekdaysMin", "weekdays", 2, t);
      };
    };
  });
})($);
var G = $.exports;
const Z = /* @__PURE__ */ M(G);
var j = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    return function(a, e, r) {
      r.updateLocale = function(d, o) {
        var i = r.Ls[d];
        if (i) return (o ? Object.keys(o) : []).forEach(function(f) {
          i[f] = o[f];
        }), i;
      };
    };
  });
})(j);
var B = j.exports;
const I = /* @__PURE__ */ M(B);
var g = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e();
  })(y, function() {
    return { name: "en", weekdays: "Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday".split("_"), months: "January_February_March_April_May_June_July_August_September_October_November_December".split("_"), ordinal: function(a) {
      var e = ["th", "st", "nd", "rd"], r = a % 100;
      return "[" + a + (e[(r - 20) % 10] || e[r] || e[0]) + "]";
    } };
  });
})(g);
var W = g.exports;
const K = /* @__PURE__ */ M(W), Q = /* @__PURE__ */ x({
  __proto__: null,
  default: K
}, [W]);
var T = { exports: {} };
(function(u, h) {
  (function(a, e) {
    u.exports = e(m);
  })(y, function(a) {
    function e(o) {
      return o && typeof o == "object" && "default" in o ? o : { default: o };
    }
    var r = e(a), d = { name: "fr", weekdays: "dimanche_lundi_mardi_mercredi_jeudi_vendredi_samedi".split("_"), weekdaysShort: "dim._lun._mar._mer._jeu._ven._sam.".split("_"), weekdaysMin: "di_lu_ma_me_je_ve_sa".split("_"), months: "janvier_février_mars_avril_mai_juin_juillet_août_septembre_octobre_novembre_décembre".split("_"), monthsShort: "janv._févr._mars_avr._mai_juin_juil._août_sept._oct._nov._déc.".split("_"), weekStart: 1, yearStart: 4, formats: { LT: "HH:mm", LTS: "HH:mm:ss", L: "DD/MM/YYYY", LL: "D MMMM YYYY", LLL: "D MMMM YYYY HH:mm", LLLL: "dddd D MMMM YYYY HH:mm" }, relativeTime: { future: "dans %s", past: "il y a %s", s: "quelques secondes", m: "une minute", mm: "%d minutes", h: "une heure", hh: "%d heures", d: "un jour", dd: "%d jours", M: "un mois", MM: "%d mois", y: "un an", yy: "%d ans" }, ordinal: function(o) {
      return "" + o + (o === 1 ? "er" : "");
    } };
    return r.default.locale(d, null, !0), d;
  });
})(T);
var A = T.exports;
const R = /* @__PURE__ */ M(A), V = /* @__PURE__ */ x({
  __proto__: null,
  default: R
}, [A]);
m.extend(F);
m.extend(P);
m.extend(J);
m.extend(U);
m.extend(Z);
m.extend(I);
m.locale(V);
m.locale({
  ...Q,
  weekStart: 1,
  formats: {
    LT: "h:mm A",
    LTS: "h:mm:ss A",
    L: "MM/DD/YYYY",
    LL: "MMMM D, YYYY",
    LLL: "MMMM D, YYYY h:mm A",
    LLLL: "dddd, MMMM D, YYYY h:mm A"
  }
});
m.updateLocale("en", {
  weekStart: 1
});
const tt = m;
export {
  y as c,
  tt as d,
  M as g
};
//# sourceMappingURL=dayjsExtension-DC5Mvhv4.mjs.map
